import { Component } from '@angular/core';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';
import { UserProfile } from 'src/app/shared/models/user-profile';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ApplicationSettingsService } from '../../application-settings/application-settings.service';

@Component({
  selector: 'app-dashboard-menu',
  templateUrl: './dashboard-menu.component.html',
  styleUrls: ['./dashboard-menu.component.less']
})
export class DashboardMenuComponent {

  constructor(public authenticationService: AuthenticationService, public theme: ThemeService, public config: ConfigService , private applicationSettingsService: ApplicationSettingsService, private currentUserService: CurrentUserService) {
  }

  centreCompetenceMode = this.applicationSettingsService.getApplicationSettings().Enable_Centre_Service;

  isSuiviNettingsHidden(): boolean {
    const user = this.currentUserService.getCurrentUser();
    if (!user) return true;
    const nettingView = user.nettingView;

    return !(user.role === UserProfile.ADMIN || user.role === UserProfile.MANAGER_CDS || (user.role === UserProfile.CP_CDS && nettingView));
  }

  isFebHidden(): boolean {
    if(!this.centreCompetenceMode) {
      return true;
    } 
    return false;
  }

  isDevisHidden(): boolean {
    if(!this.centreCompetenceMode) {
      return true;
    }
    const user = this.currentUserService.getCurrentUser();
    if (!user) return true;
    return !(user.role === UserProfile.ADMIN
      || user.role === UserProfile.MANAGER_CDS
      || user.role === UserProfile.SERVICE_MANAGER
      || user.role === UserProfile.CP_SNCF
      || user.role === UserProfile.CP_CDS);
  }

  isDevisValidationHidden(): boolean {
    if(!this.centreCompetenceMode) {
      return true;
    }
    const user = this.currentUserService.getCurrentUser();
    if (!user) return true;
    return !(user.role === UserProfile.ADMIN
      || user.role === UserProfile.SERVICE_MANAGER
      || user.role === UserProfile.CP_SNCF);
  }

  isAuditHidden(): boolean {
    //visible uniquement par le profil admin 
    const user = this.currentUserService.getCurrentUser();
    if (!user) return true;
    if( user.role !== UserProfile.ADMIN )
      return true
    return  !this.centreCompetenceMode;
  }

}
